var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import copy from 'copy-to-clipboard';
import { format, parseISO } from 'date-fns';
import { saveAs } from 'file-saver';
import { csv2json, json2csv } from 'json-2-csv';
var CLIPBOARD_TABLE_CONVERT_OPTIONS = {
    delimiter: {
        field: '\t',
        wrap: '',
        eol: '\r\n'
    }
};
function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
export function exportRowsToClipboardTsv(rows) {
    return json2csv(rows, CLIPBOARD_TABLE_CONVERT_OPTIONS);
}
function clipboardTsvToHtmlTableFragment(tsv) {
    var trimmed = tsv.replace(/^\uFEFF/, '').trim();
    if (!trimmed) {
        return '<table></table>';
    }
    var rows = csv2json(trimmed, CLIPBOARD_TABLE_CONVERT_OPTIONS);
    if (!rows.length) {
        return '<table></table>';
    }
    var keys = Object.keys(rows[0]);
    var header = '<thead><tr>' +
        keys.map(function (k) { return "<th>".concat(escapeHtml(k), "</th>"); }).join('') +
        '</tr></thead>';
    var body = '<tbody>' +
        rows
            .map(function (row) {
            return ('<tr>' +
                keys
                    .map(function (k) {
                    var v = row[k];
                    var s = v === null || v === undefined ? '' : String(v);
                    return "<td>".concat(escapeHtml(s), "</td>");
                })
                    .join('') +
                '</tr>');
        })
            .join('') +
        '</tbody>';
    return "<table>".concat(header).concat(body, "</table>");
}
export function exportRowsToHtmlTableFragment(rows) {
    return clipboardTsvToHtmlTableFragment(exportRowsToClipboardTsv(rows));
}
export function copyToClipboard(rows) {
    return __awaiter(this, void 0, Promise, function () {
        var tsv, tableHtml, htmlDocument, canUseRichClipboard, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    tsv = exportRowsToClipboardTsv(rows);
                    if (!tsv.trim()) {
                        return [2 /*return*/, false];
                    }
                    tableHtml = clipboardTsvToHtmlTableFragment(tsv);
                    htmlDocument = "<!DOCTYPE html><html><body><!--StartFragment-->".concat(tableHtml, "<!--EndFragment--></body></html>");
                    canUseRichClipboard = typeof navigator !== 'undefined' &&
                        globalThis.isSecureContext === true &&
                        navigator.clipboard != null;
                    if (!canUseRichClipboard) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.write([
                            new ClipboardItem({
                                'text/plain': new Blob([tsv], { type: 'text/plain;charset=utf-8' }),
                                'text/html': new Blob([htmlDocument], {
                                    type: 'text/html;charset=utf-8'
                                })
                            })
                        ])];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4:
                    copy(tsv);
                    return [2 /*return*/, true];
            }
        });
    });
}
export var saveAsCSV = function (csvText, displayedFileName) {
    var blob = new Blob([csvText], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, "".concat(displayedFileName, ".csv"));
};
export var createFileName = function (fileName) {
    var baseName = fileName && fileName.trim().length > 0 ? fileName : 'export';
    return baseName.replace(/ /g, '_').toLowerCase();
};
export var createFilenameFromFilters = function (filters) {
    if (!filters)
        return '';
    var values = [];
    if (filters.period) {
        values.push(filters.period.replace(/ /g, '_').toLowerCase());
    }
    if (filters.dateFrom && filters.dateTo) {
        var period = "".concat(format(parseISO(filters.dateFrom), 'ddMMMyyyy'), "-").concat(format(parseISO(filters.dateTo), 'ddMMMyyyy'));
        values.push(period);
    }
    if (filters.orgUnit) {
        values.push("team-".concat(filters.orgUnit));
    }
    if (filters.user) {
        values.push("user-".concat(filters.user));
    }
    if (values.length === 0)
        return '';
    return values.join('-');
};
